import React, { useContext, useEffect, useState } from 'react'
import { message, Select, Skeleton } from 'antd'

import { useFetch } from '../../services/ApiService';


function SelectDropdown(props) {

    const { Option } = Select;
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const { idKey, fieldKey, blankOption, ...newProps } = props;
    const { fetchApi } = useFetch();

    async function getDropdownData(path) {
        await fetchApi(path, 'GET').then(res => {

            const resData = Array.from(res);

            const sortedData = Array.from(resData).sort((a, b) => {
                let fa, fb;
                if (fieldKey !== undefined) {
                    fa = a[fieldKey].toLowerCase();
                    fb = b[fieldKey].toLowerCase();
                }
                else {
                    fa = a.name.toLowerCase();
                    fb = b.name.toLowerCase();
                }

                if (fa < fb) {
                    return -1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            });
            
            setOptions(sortedData);
        }).catch(err => {
            console.log(err);
        })

        setLoading(false);
    }

    function fieldKeyMap(item, keys) {
        if (Array.isArray(keys)) {
            let fieldKey = '';

            keys.map(key => {
                if (fieldKey === '') {
                    fieldKey = item[key]
                }
                else {
                    fieldKey = fieldKey + ' ' + item[key]
                }
            })

            return fieldKey
        }
        else {
            return item[keys]
        }
    }

    useEffect(() => {
        getDropdownData(props.path)
        return () => {
            setLoading(true);
        }
    }, [props.path])

    return (
        <>
            {
                loading ? <Skeleton.Button block active style={{ height: '32px' }} /> :
                    <Select mode={props.mode !== undefined ? props.mode : ''} className='w-100' loading={loading} {...newProps} showArrow>
                        {
                            blankOption && <Option value=""> </Option>
                        }
                        {
                            options.map((item, idx) => (
                                <Option value={props.idKey !== undefined ? item[props.idKey] : item['id']} key={idx}>
                                    {
                                        props.fieldKey !== undefined ?
                                            fieldKeyMap(item, props.fieldKey) : item['name']
                                    }
                                </Option>
                            ))
                        }

                    </Select>
            }
        </>
    )
}

export default SelectDropdown